import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentMethods = ({ paymentMethods, onAddPayment, onRemovePayment, onSetDefault }) => {
  const [showAddForm, setShowAddForm] = useState(false);

  const getCardIcon = (brand) => {
    switch (brand?.toLowerCase()) {
      case 'visa': return 'CreditCard';
      case 'mastercard': return 'CreditCard';
      case 'amex': return 'CreditCard';
      case 'discover': return 'CreditCard';
      default: return 'CreditCard';
    }
  };

  const getCardColor = (brand) => {
    switch (brand?.toLowerCase()) {
      case 'visa': return 'text-blue-600';
      case 'mastercard': return 'text-red-600';
      case 'amex': return 'text-green-600';
      case 'discover': return 'text-orange-600';
      default: return 'text-muted-foreground';
    }
  };

  const AddPaymentForm = () => (
    <div className="bg-muted/50 rounded-lg p-4 border border-border">
      <h4 className="font-medium text-card-foreground mb-4">Add New Payment Method</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-card-foreground mb-2">
            Card Number
          </label>
          <input
            type="text"
            placeholder="1234 5678 9012 3456"
            className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-card-foreground mb-2">
            Cardholder Name
          </label>
          <input
            type="text"
            placeholder="John Doe"
            className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-card-foreground mb-2">
            Expiry Date
          </label>
          <input
            type="text"
            placeholder="MM/YY"
            className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-card-foreground mb-2">
            CVV
          </label>
          <input
            type="text"
            placeholder="123"
            className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>
      </div>
      <div className="flex gap-3">
        <Button
          variant="default"
          onClick={() => {
            onAddPayment();
            setShowAddForm(false);
          }}
        >
          Add Card
        </Button>
        <Button
          variant="outline"
          onClick={() => setShowAddForm(false)}
        >
          Cancel
        </Button>
      </div>
    </div>
  );

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-card-foreground">Payment Methods</h2>
          <p className="text-sm text-muted-foreground">Manage your saved payment methods</p>
        </div>
        {!showAddForm && (
          <Button
            variant="outline"
            onClick={() => setShowAddForm(true)}
            iconName="Plus"
            iconPosition="left"
          >
            Add Card
          </Button>
        )}
      </div>
      {showAddForm && (
        <div className="mb-6">
          <AddPaymentForm />
        </div>
      )}
      <div className="space-y-4">
        {paymentMethods?.map((method) => (
          <div
            key={method?.id}
            className="flex items-center justify-between p-4 border border-border rounded-lg bg-background"
          >
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
                <Icon 
                  name={getCardIcon(method?.brand)} 
                  size={20} 
                  className={getCardColor(method?.brand)} 
                />
              </div>
              <div>
                <div className="flex items-center space-x-2">
                  <p className="font-medium text-foreground">
                    {method?.brand?.toUpperCase()} •••• {method?.last4}
                  </p>
                  {method?.isDefault && (
                    <span className="px-2 py-1 bg-success/10 text-success text-xs rounded-full font-medium">
                      Default
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground">
                  Expires {method?.expiryMonth}/{method?.expiryYear}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-2">
              {!method?.isDefault && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onSetDefault(method?.id)}
                >
                  Set Default
                </Button>
              )}
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onRemovePayment(method?.id)}
                iconName="Trash2"
                className="text-error hover:text-error"
              />
            </div>
          </div>
        ))}

        {paymentMethods?.length === 0 && !showAddForm && (
          <div className="text-center py-8">
            <Icon name="CreditCard" size={48} className="text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground mb-4">No payment methods added yet</p>
            <Button
              variant="outline"
              onClick={() => setShowAddForm(true)}
              iconName="Plus"
              iconPosition="left"
            >
              Add Your First Card
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentMethods;